import Grid from "@mui/material/Grid";
import { Box, Stack } from "@mui/material";
import { LabelTemplate } from "./styles/table";
import { Employee } from "../types/processTypes";

import { BasicPostAppliedEnglishMermaid } from "./components/basic/BasicPostApplied";
import { BasicDetail } from "./components/basic/BasicDetail";
import { BasicExperience } from "./components/basic/BasicExperience";
import { BasicSkillsOneLineHorz } from "./components/basic/BasicSkills";
import { BasicPassport } from "./components/basic/BasicPassport";
import { BasicFace } from "./components/basic/BasicFace";
import { BasicStand } from "./components/basic/BasicStand";
import { BasicRemarksUltra } from "./components/basic/BasicRemarks";
import Image from "mui-image";

import { BasicPassportScanNoBroker } from "./components/basic/BasicPassportScan";
import {
  BasicHeader,
  BasicHeaderNoBorder,
} from "./components/basic/BasicHeader";
import { Company } from "../../setups/types/setupTypes";
import { BasicLanguageMermaid } from "./components/basic/BasicLanguage";
import { MedicalCertificate } from "./components/basic/MedicalCertificate";

interface Props {
  selectedCompany: Company;
  currentEmployee: Employee;
  backgroundColor: string;
  cvTemplate: LabelTemplate;
}
function BasicTemplateMermaid({
  selectedCompany,
  currentEmployee,
  backgroundColor,
  cvTemplate,
}: Props) {
  //a08745;f2f1f0 fffcf2
  return (
    <>
      <Box id="personalData" sx={{ p: 1 }}>
        <Grid
          container
          spacing={cvTemplate.spacing}
          sx={{
            p: 1,
            backgroundColor: backgroundColor,
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              height: "90%",
              // mb: 1,
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeaderNoBorder
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Grid>
          <Grid
            container
            item
            xs={12}
            spacing={cvTemplate.spacing}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12}>
              {cvTemplate && currentEmployee && (
                <Image src="/mermaidCvHeader.jpeg" alt="mermaid Cv Header" />
              )}
            </Grid>
            <Grid container item xs={12}>
              {cvTemplate && currentEmployee && (
                <BasicPostAppliedEnglishMermaid
                  currentEmployee={currentEmployee}
                  template={{ ...cvTemplate, showCellBorders: true }}
                />
              )}
            </Grid>
          </Grid>

          <Grid item md={6} xs={12}>
            {cvTemplate && currentEmployee && (
              <BasicPassport
                currentEmployee={currentEmployee}
                template={{ ...cvTemplate, showCellBorders: true }}
                showHeader={true}
                showPassportNumber={true}
                showIssueDate={true}
                showPlaceOfIssue={true}
                showExpiryDate={true}
              />
            )}
            {cvTemplate && currentEmployee && (
              <BasicDetail
                currentEmployee={currentEmployee}
                template={{ ...cvTemplate, showCellBorders: true }}
                showHeader={true}
                showName={false}
                showNationality={false}
                showReligion={true}
                showDateOfBirth={true}
                showAge={true}
                showPlaceOfBirth={true}
                showMaritalStatus={true}
                showNumberOfChildren={true}
                showWeightHeight={true}
                showComplexion={true}
                showEducation={false}
                showLivingTown={false}
                showEmployeeTelephone={false}
                showContactName={false}
                showContactTelephone={false}
              />
            )}
            {cvTemplate && currentEmployee && (
              <BasicLanguageMermaid
                currentEmployee={currentEmployee}
                template={{ ...cvTemplate, showCellBorders: true }}
                showEducation={false}
              />
            )}
            {cvTemplate && currentEmployee && (
              <BasicExperience
                currentEmployee={currentEmployee}
                template={{ ...cvTemplate, showCellBorders: true }}
                type="basic"
              />
            )}
            {cvTemplate && currentEmployee && (
              <BasicSkillsOneLineHorz
                currentEmployee={currentEmployee}
                template={{ ...cvTemplate, showCellBorders: true }}
              />
            )}
            {cvTemplate && currentEmployee && (
              <BasicRemarksUltra
                currentEmployee={currentEmployee}
                template={{ ...cvTemplate, showCellBorders: true }}
              />
            )}
          </Grid>
          <Grid item md={6} xs={12}>
            <Stack
              spacing={cvTemplate.spacing}
              sx={{
                alignItems: "center",
              }}
            >
              {cvTemplate && currentEmployee && (
                <BasicDetail
                  currentEmployee={currentEmployee}
                  template={{ ...cvTemplate, showCellBorders: true }}
                  showHeader={true}
                  showName={true}
                  showNationality={true}
                  showReligion={false}
                  showDateOfBirth={false}
                  showAge={false}
                  showPlaceOfBirth={false}
                  showMaritalStatus={false}
                  showNumberOfChildren={false}
                  showWeightHeight={false}
                  showComplexion={false}
                  showEducation={false}
                  showLivingTown={false}
                  showEmployeeTelephone={false}
                  showContactName={false}
                  showContactTelephone={false}
                />
              )}

              <Stack direction="row" spacing={1}>
                {cvTemplate && currentEmployee && (
                  <BasicStand
                    currentEmployee={currentEmployee}
                    template={cvTemplate}
                  />
                )}
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Box>
      <Stack
        id="passportData"
        sx={{
          p: 1,
          pt: 1,
          backgroundColor: backgroundColor,
          minHeight: "1500px",
        }}
      >
        {cvTemplate.addPassportHeader && (
          <Box
            sx={{
              height: "90%",
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeader
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Box>
        )}
        {cvTemplate && currentEmployee && (
          <Stack
            alignItems="center"
            spacing={5}
            sx={{
              mt: 15,
            }}
          >
            <BasicPassportScanNoBroker
              currentEmployee={currentEmployee}
              template={cvTemplate}
            />
            <BasicFace
              currentEmployee={currentEmployee}
              template={cvTemplate}
            />
          </Stack>
        )}
      </Stack>
      <Stack
        id="medicalData"
        sx={{
          p: 1,
          pt: 1,
          backgroundColor: backgroundColor,
          minHeight: "1500px",
        }}
      >
        {cvTemplate && currentEmployee && (
          <Box
            sx={{
              mt: 15,
            }}
          >
            <MedicalCertificate
              currentEmployee={currentEmployee}
              template={cvTemplate}
            />
          </Box>
        )}
      </Stack>
    </>
  );
}

export default BasicTemplateMermaid;
